<template>
  <router-view :pages="pages" @authState="authState" />
</template>

<script>
export default {
  name: "Root",
  props: {
    pages: Array,
  },
  methods: {
    authState(status, token) {
      this.$emit("authState", status, token);
    },
  },
};
</script>